<div class="home-container">
  <div class="sport-tabs">
    @for (item of navItems; track item) {
      @if (navService.isSportVisible(item.label.toLowerCase(), "header") | async) {
        <a class="sport-tab-link" 
           [routerLink]="item?.path" 
           routerLinkActive="active" 
           #rla="routerLinkActive" 
           [class.active]="rla?.isActive">
          {{ ((loading$ | async) && isCurrentRoute(item.label) ? "..." : item.label) | translate }}
        </a>
      }
    }
  </div>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
